import React, { Component, useEffect, useRef, useState } from 'react';
import { Input, Item, Text, Button, Toast, View, FormControl, Image } from 'native-base';
import { ScrollView, ActivityIndicator, Linking, TextInput, Platform } from 'react-native';
import firebase from 'firebase';
import googleSignInImage from './img/googlelogin.png'
//import { withNavigationFocus } from 'react-navigation';
import * as firebaseui from 'firebaseui'
import { NativeBaseProvider } from 'native-base';
// import appleAuth, {
//     AppleAuthRequestScope,
//     AppleAuthRequestOperation, AppleButton
// } from '@invertase/react-native-apple-authentication';
//import { GoogleSignin, GoogleSigninButton } from '@react-native-community/google-signin';
//import FacebookSdk, { LoginButton, LoginManager, AccessToken, } from 'react-native-fbsdk';
//const background = require('./LoginBackground.jpg')
import db, { loginToFirebase, registerToFirebase, signOut } from '../acebase';
import { liveTTScoreboardColor } from '../../livettscoreboard.config';
import { liveTTScoreboardTheme } from "../liveTTScoreboardTheme";

async function loginToGoogle(){
   var googleProvider = new firebase.auth.GoogleAuthProvider()
   googleProvider.addScope("https://www.googleapis.com/auth/userinfo.email")
   googleProvider.addScope("https://www.googleapis.com/auth/userinfo.profile")
   firebase.auth().useDeviceLanguage()
   firebase.auth().signInWithPopup(googleProvider).then((result) => {
    /** @type {firebase.auth.OAuthCredential} */
    var credential = result.credential;
    console.log(result.credential.toJSON())
    // This gives you a Google Access Token. You can use it to access the Google API.
    var token = credential.accessToken;
    console.log("token",token)
    // The signed-in user info.
    var user = result.user;
    console.log("user",user)
    // IdP data available in result.additionalUserInfo.profile.
      // ...
  }).catch((error) => {
    // Handle Errors here.
    var errorCode = error.code;
    var errorMessage = error.message;
    // The email of the user's account used.
    var email = error.email;
    // The firebase.auth.AuthCredential type that was used.
    var credential = error.credential;
    console.log(credential,email, errorCode, errorMessage)
    // ...
  });
}


export default function Login() {

    let ui = useRef(new firebaseui.auth.AuthUI(firebase.auth()))
    useEffect(()=>{
ui.current.start("#uicontainer", {
    signInOptions:[
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
        firebase.auth.GoogleAuthProvider.PROVIDER_ID
    ]
} )

return ()=>{
    ui.current.delete()
}
    }, [])
        let [doneLoading, setDoneLoading] = useState(false)
        let [password, setPassword] = useState("")
        let [email,setEmail] = useState("")
        let [showSignIn, setShowSignIn] = useState(false)
        let [showRegister, setShowRegister] = useState(false)
        let [token, setToken] = useState("")
    return (
        <NativeBaseProvider theme={liveTTScoreboardTheme}>

                <link type="text/css" rel="stylesheet" href="https://www.gstatic.com/firebasejs/ui/5.0.0/firebase-ui-auth.css" />
            <View >
                <Text textAlign={"center"} padding={3} fontSize={"5xl"} fontWeight="bold" color={liveTTScoreboardColor}>Live TT Scoreboard</Text>
<div id="uicontainer"></div>
            </View>
            
            {/* <View>
                <FormControl>
                    <FormControl.Label>Email</FormControl.Label>
                    <Input value={email} 
                    onChangeText={setEmail}

                    ></Input>
                     <FormControl.Label>Password</FormControl.Label>
                    <Input value={password} 
                    onChangeText={setPassword}
                    secureTextEntry={true}
                    ></Input>
                    <View padding={1}>
                        <Button
                        onPress={async ()=>{
                           let result = await loginToFirebase(email, password)
                           console.log(result)
                        }}
                        >
                            <Text>Login</Text>
                        </Button>
                    </View>
                    <View padding={1}>
                        <Button
                        
                        onPress={async ()=>{
                            let result = await registerToFirebase(email, password)
                            console.log(result)
                         }}>
                            <Text>Register</Text>
                        </Button>
                    </View>
                    <View padding={1}>
                        <Button
                        
                        onPress={async ()=>{
                            let result = await signOut()
                            console.log(result)
                         }}>
                            <Text>Sign Out</Text>
                        </Button>
                    </View>
                    <View>
                        <Button variant={"ghost"} onPress={()=>{
                            loginToGoogle()
                        }}>
                        <Image  height={46} width={191}  source={googleSignInImage}  ></Image>
                        </Button>
                    </View>
                    <Input value={token} 
                    onChangeText={setToken}
                    secureTextEntry={false}
                    ></Input>
                     <View>
                        <Button variant={"ghost"} onPress={()=>{
                            let provider = new firebase.auth.GoogleAuthProvider()
                            let tokenGoogle={
                                "providerId": "google.com",
                                "signInMethod": "google.com",
                                "oauthIdToken": "eyJhbGciOiJSUzI1NiIsImtpZCI6Ijk4NmVlOWEzYjc1MjBiNDk0ZGY1NGZlMzJlM2U1YzRjYTY4NWM4OWQiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJhY2NvdW50cy5nb29nbGUuY29tIiwiYXpwIjoiNTg3NDM1NzU0ODg3LWtlMmJzMWh2Nm51dG51dXRtbG1rNTh0OTBua2M4dTRmLmFwcHMuZ29vZ2xldXNlcmNvbnRlbnQuY29tIiwiYXVkIjoiNTg3NDM1NzU0ODg3LWtlMmJzMWh2Nm51dG51dXRtbG1rNTh0OTBua2M4dTRmLmFwcHMuZ29vZ2xldXNlcmNvbnRlbnQuY29tIiwic3ViIjoiMTA4MjA3NzU4MjIxMTMwMjM2NDc1IiwiZW1haWwiOiJqYWNrYm1jY2FydGh5QGdtYWlsLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJhdF9oYXNoIjoiZzhPSjZ5MU91OXloYVFRVXVIOERzQSIsImlhdCI6MTY3OTQ3MTM5MSwiZXhwIjoxNjc5NDc0OTkxfQ.h5yJyO4X3hf9JausPW8BmmnL6CInJYXV2OrLKjzF_paXnWLTAVJqLxaifHvI7IZ2Z--xmxFzOB1mB7o-IuYQTxqKxTti7sDWFNGL1TTxAahKrToNmUIUCOui5vluna8PM_lMIjOu-_46Np2DZ_hXdWpxUeUz9x5Nl8rmuaS6oRnYXN8REOW579X4X8cZqeS1jWUD4vaKGbh2Xap6Bj82inNYKofo5tFknUTVz_4dBhK5l5ZNBZbKs56kqaG7DlGdo9m5gQOg3HsbISjmXfXTdRfgCqxBSR1u249sz9z8JahkooBP5fW8UTUS0DkieTK574nVDyDIMGXPEusEM-FNpA",
                                "oauthAccessToken": "ya29.a0AVvZVsoGbfX_pVrtR355fc650cAEBGc7r7rXBCKg8tCJRpgXz0_zoXkQLFMTVPATTOgShnHyI9QLgYPn20HU7iLTWD8Y9_jcgA_VMRvXjgfxMtGmOosB36RnH3DwnoIxjpc3nZxTeIMR2pdLbQbXMwT2iylkWAaCgYKAa8SARISFQGbdwaIZQsnj2t55HJ22Fq9wfyWyw0165"
                            }
                            let emailCreds = firebase.auth.EmailAuthProvider.credential("jackbmccarthy@gmail.com", "America1!!")
                            let creds = firebase.auth.GoogleAuthProvider.credential(tokenGoogle.oauthIdToken,tokenGoogle.oauthAccessToken)
                            firebase.auth().signInWithCredential(emailCreds)
                        }}>
                        <Text>Try Token</Text>
                        </Button>
                    </View>
                </FormControl>
            </View> */}
        </NativeBaseProvider>

    )
}